import { createStore } from 'vuex';
import {dwc} from '../modules';

const store = createStore({
    modules: {
        dwc,
    },
    mutations: {
        updateIsLoading (state, Loading) {
            state.isLoading = Loading;
        }
    },
});

export default store;